export default "__VITE_ASSET__DoeWWeG8__"